<template>
  <div class="tab-group">
    <div class="tab" :class="{ selected: talent.participant_id == state.currentSelectedTalent }"
      @click="clickTab(talent.participant_id)"
      v-for="(talent, index) in openedTalents" :key="talent.participant_id">
      <p>
        {{ talent?.candidate?.first_name || talent?.pending_first_name || '' }}
        {{ talent?.candidate?.last_name || talent?.pending_last_name || '' }}
      </p>
      <i @click.stop="clickCloseTab(talent.participant_id)" class="bi bi-x-lg"></i>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "@/assets/style/variables.scss";

  .tab-group {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    scroll-behavior: smooth;
    flex-shrink: 0;
    
    .tab {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-shrink: 0;
      padding: 12px 20px 12px 20px;
      gap: 10px;
      cursor: pointer;

      border: 1px solid var(--light-grey-color);
      border-bottom: none;

      &:first-child {
        border-top-left-radius: 4px;
      }

      &:last-child {
        border-top-right-radius: 4px;
      }

      &:hover {
        background-color: $primary-100-color;
        color: $secondary-color;
      }

      &.selected {
        background-color: $primary-color;
        color: $secondary-color;
      }

      p {
        font-family: $bioSans;
        font-size: 16px;
      }

      i {
        cursor: inherit;
      }
    }
  }
</style>

<script setup lang="ts">
import { reactive, computed, onMounted } from "vue";

const emits = defineEmits(["openedTalents", "selectedTalent"]);

const {
  openedTalents,
} = defineProps<{
  openedTalents?: any[],
}>();

const state = reactive({
  currentSelectedTalent: openedTalents[0].participant_id,
});

function clickTab(participantId: string) {
  state.currentSelectedTalent = participantId;
  emits("selectedTalent", state.currentSelectedTalent);
}

function clickCloseTab(participantId: string) {
  const newOpenedTalents = openedTalents.filter((v) => v.participant_id != participantId);
  emits('openedTalents', newOpenedTalents);
  if (state.currentSelectedTalent == participantId) {
    state.currentSelectedTalent = newOpenedTalents[0].participant_id;
    emits("selectedTalent", state.currentSelectedTalent);
  }
}

onMounted(() => {
  emits('selectedTalent', state.currentSelectedTalent);
});

</script>